module.exports = __webpack_public_path__ + "media/images/fbcalls/fbcalls_o_que_e-f73a72572fd70cf0a41a1f8d0dda65c3.png";